import SummaryBadge from './SummaryBadge';
export default SummaryBadge;
